import React from 'react';
import { withStyles } from '@material-ui/core';
import ReactGA from 'react-ga';

const styles = theme => {
  return {
    navCard: {
      paddingBottom: theme.spacing.unit,
      borderRadius: '10px',
      border: `4px solid ${theme.palette.primary.main}`,
      boxShadow: '0 0 10px rgba(0,0,0,0.4 )',
      height: 250,
      width: 150,
      backgroundColor: theme.palette.common.white,
      textAlign: 'center',
      marginLeft: '-35px',
      marginRight: '-35px',
      marginTop: '50px',
      textDecoration: 'none',
      fontSize: 22,
      fontFamily: 'GoodDog Plain',
      color: theme.palette.primary.main,
      transition: 'margin 200ms',
      outline: '1px solid transparent',
      '&:hover': {
        zIndex: 20,
        boxShadow: '0 0 10px rgba(0,0,0,0.8)'
      },
      [theme.breakpoints.down('xs')]: {
        height: 150,
        width: 75,
        marginLeft: '-15px',
        marginRight: '-15px',
        marginTop: '30px',
        fontSize: 22
      }
    },
    navCardTitle: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      width: '144px',
      marginLeft: '-1px',
      marginTop: '-1px',
      display: 'flex',
      marginBottom: '4px',
      height: 30,
      textAlign: 'center',
      fontSize: '30px',
      borderRadius: '8px 8px 0 0',
      paddingLeft: theme.spacing.unit,
      [theme.breakpoints.down('xs')]: {
        width: '72px',
        fontSize: '17px',
        marginBottom: '0',
        height: 'auto'
      }
    },
    nav1: {
      zIndex: 1,
      marginTop: '45px',
      '&:hover': {
        marginTop: 30
      },

      [theme.breakpoints.down('xs')]: {
        marginTop: '30px',
        '&:hover': {
          marginTop: 15
        }
      }
    },
    nav2: {
      zIndex: 2,
      marginTop: '20px',
      '&:hover': {
        marginTop: 10
      }
    },
    nav3: {
      zIndex: 3,
      marginTop: '15px',
      '&:hover': {
        marginTop: 5
      }
    },
    nav4: {
      zIndex: 4,
      marginTop: '20px',
      '&:hover': {
        marginTop: 10
      }
    },
    nav5: {
      zIndex: 5,
      marginTop: '50px',
      '&:hover': {
        marginTop: 30
      },

      [theme.breakpoints.down('xs')]: {
        marginTop: '30px',
        '&:hover': {
          marginTop: 15
        }
      }
    }
  };
};

const NavCard = class extends React.PureComponent {
  render() {
    const { classes, link, name, rotate, zIndexVal, image } = this.props;

    return (
      <a
        className={`${classes.navCard} ${classes[`nav${zIndexVal}`]}`}
        style={{ transform: `rotateZ(${rotate}deg)` }}
        href={`/#${link}`}
        onClick={() => {
          ReactGA.ga('send', 'event', 'navigation', 'goto', link);
        }}
      >
        <span className={classes.navCardTitle}>{name}</span>
        <img
          src={`/images/cards/${image}.jpg`}
          alt={`card ${image}`}
          style={{ width: '90%', padding: '3px', boxSizing: 'content-box' }}
        />
      </a>
    );
  }
};

export default withStyles(styles)(NavCard);
